import { useState } from "react";

export default function useObjectState<T=any>(defaultValues: T): [T, (partialState: Partial<T>) => void] {
    const [state, setState] = useState({...defaultValues});

    function set(partialState: Partial<T>) {
        setState(prev => ({...prev, ...partialState}));
    }

    return [state, set];
}